module.exports = __webpack_public_path__ + "static/img/wap.2b964f4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/en/来华/wap.svg
// module id = 9Owc
// module chunks = 16